import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  Alert,
  CircularProgress,
  Typography,
  Chip,
  Box,
} from '@mui/material';

export default function AddFilingDialog({ open, onClose, onSave, projectName }) {
  const [label, setLabel] = useState('');
  const [url, setUrl] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleClose = () => {
    setLabel('');
    setUrl('');
    setError(null);
    onClose();
  };

  const handleSave = async () => {
    if (!label.trim()) {
      setError('Label is required');
      return;
    }
    if (!url.trim()) {
      setError('URL is required');
      return;
    }

    try {
      setSaving(true);
      setError(null);
      await onSave(label.trim(), url.trim());
      handleClose();
    } catch (err) {
      console.error('Error creating filing:', err);
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Filing Page</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {error && (
            <Alert severity="error" onClose={() => setError(null)}>
              {error}
            </Alert>
          )}

          <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              Adding filing to project:
            </Typography>
            <Chip label={projectName} />
          </Box>

          <TextField
            label="Label"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            fullWidth
            autoFocus
            required
            size="small"
            placeholder="e.g. Filing 345000"
          />

          <TextField
            label="URL"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            fullWidth
            required
            size="small"
            placeholder="https://..."
          />

        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} disabled={saving}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={saving || !label.trim() || !url.trim()}
          sx={{ backgroundColor: '#5f94de' }}
        >
          {saving ? <CircularProgress size={20} /> : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
